import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// In-app confirm (window.confirm is silently blocked in some phone browsers / installed apps).
export default function SendConfirmDialog({ step, resend, onCancel, onConfirm }) {
  const coord = step?.kind === "coord";
  return (
    <AlertDialog open={!!step} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-slate-900 border-slate-700 text-slate-100" data-testid="pano-send-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>{coord ? "Coordinates look off" : resend ? "Send to Pano again?" : "Send to Pano?"}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-300">
            {coord ? `${step.msg} Send anyway?` : resend
              ? "This audit was already sent to Pano. Sending again creates a second response on their form."
              : "This submits the audit to Pano's Google Form now."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-slate-800 border-slate-700" data-testid="pano-send-confirm-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-sky-600 hover:bg-sky-500" data-testid="pano-send-confirm-ok">
            {coord ? "Send anyway" : "Send"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
